
import { cn } from "@bem-react/classname";
import {  deleteResult, getMark, getMean, getPortal, getProbNum, getTeacherMark, ITest, ITests, IUser, IUserResult, IUserResults, selectIsTestHover, selectIsUserHover, selectTeacherJournal, setHoverTest, setHoverUser, setTeacherMark } from "modules/TeacherJournal";
import { FC, useCallback, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../Journal.scss"
import "react-datepicker/dist/react-datepicker.css";


const Result: FC<{result: IUserResult, test:ITest, deletable:boolean}> = ({result, test, deletable}) => {
    const jcn = cn('Journal')
    const state = useSelector(selectTeacherJournal)
    const {mark, score, lowered} = getMark(result, test)
    const markStyle = {color: 'default'}
    let titleadd = ''
    if (lowered) {
        markStyle.color = 'red'
        titleadd = ', снижена за опоздание'
    }
    const probsTxt = result.probs.map((item, index) => item.res).join(' ')
    const dispatch = useDispatch()
    return <div className={jcn('ResultRow') + (test.isOpen?(" "+jcn('ResultRowOpen')):"")}>
        
        {test.isOpen?<>
            <div className={jcn('Probline')}>
            {result.probs.map((item, index) => <span className={jcn('Problineitem')} title={getProbNum(state, item) + '\n' + (item.answer?item.answer:'')} key={index}>{item.res}</span>)}
        </div>
        </>:<>
            {state.options.showMark & 1?<span title={"Оценка" + titleadd} style={markStyle}>{mark}</span>:''}
            {state.options.showMark === 3?<span> / </span>:''}
            {state.options.showMark & 2?
            <a 
                onClick = {(e)=>{e.stopPropagation()}}
                title={"Баллы\n" + probsTxt} 
                target="_blank" 
                rel="noreferrer" 
                href={"https://"+getPortal(state)+"/teacher?pupil_id="+result.user+"&test="+result.id}
            >
                {score}
            </a>:''}
            {state.options.showMark === 3?<>
            {result.checked === 3?<img className={jcn('rno')} src="/img/retest.png" alt="Требуется работа над ошибками" title="Требуется работа над ошибками"/>:""}
            {result.checked === 4?<img className={jcn('rno')} src="/img/retest_done.png" alt="Работа над ошибками выполнена" title="Работа над ошибками выполнена"/>:""}
            </>:''}
            {deletable?<img style={{cursor: 'pointer'}} src="/img/cross.png" alt="Удалить" title="Удалить" onClick={(e)=>{e.stopPropagation(); if (window.confirm('Удалить?')) dispatch(deleteResult(result))}}/>:''}
        </>}
        
    </div>
}

const ResultList: FC<{test: ITest, results:IUserResults, index: number, user: IUser}> = ({test, results, index, user}) => {
    const jcn = useMemo(()=>cn('Journal'), [])
    const state = useSelector(selectTeacherJournal)
    const dispatch = useDispatch()
    const teacherMark = getTeacherMark(state, test, user)
    const tHoverState = useSelector(selectIsTestHover(test.id))
    const uHoverState =  useSelector(selectIsUserHover(user.id))
    const hoverState = tHoverState || uHoverState
    const setTeacherMarkHlr = useCallback(()=>{
        const new_value = prompt('Изменить оценку в журнале', teacherMark?teacherMark:'')
        if (new_value !== null && new_value !== teacherMark){
            dispatch(setTeacherMark({portal: test.portal, subject: test.subject, user_id: user.id, test_id: test.id, mark: new_value}))
        }
    }, [teacherMark, dispatch, test.id, test.portal, test.subject, user.id])
    const ref = useRef(null as (HTMLDivElement|null))
    useEffect(()=>{
        if (ref.current !== null){
            if (hoverState){
                ref.current.classList.add(jcn('ResultHover'))
            } else {
                ref.current.classList.remove(jcn('ResultHover'))
            }
        }
    }, [hoverState, jcn])
    return useMemo(()=><div ref={(el) => ref.current = el} className={(index % 2 ? jcn('Result'): jcn('Result Even'))} onClick={setTeacherMarkHlr} onMouseEnter={()=>{dispatch(setHoverTest(test.id)); dispatch(setHoverUser(user.id))}} onMouseLeave={()=>{dispatch(setHoverTest(null)); dispatch(setHoverUser(null))}}>
        {teacherMark?<div className={jcn('ResultRow')} title="Изменить оценку в журнале"><span>{teacherMark}</span></div>:''}
        {results.map((res, index) => <Result key={index} result={res} test={test} deletable={results.length > 1}/>)}
    </div>, [teacherMark, dispatch, jcn, index, results, setTeacherMarkHlr, test, user.id])
}

export const UserRow: FC<{user: IUser, results: IUserResults, tests: ITests, index:number}> = ({user, results, tests, index}) => {
    const jcn = cn('Journal')
    const state = useSelector(selectTeacherJournal)
    const mean = getMean(state, tests, results, user)
    return <>
    <div className={jcn('Pupil')}><span style={{textAlign: 'right', minWidth: '20px', display: 'inline-block'}}>{index+1}.</span> {user.reverse_name}</div>
    {tests.map((test, index)=><ResultList user={user} index={index} key={index} test={test} results={results.filter((i)=>i.test === test.id)}/>)}
    <div className={jcn('PupilMean')}>
        {mean?mean.toLocaleString():''}
    </div>
    </>
}